/* StarLux - accepted-card note + cart reassurance
   Shows which cards we accept at every point that leads to checkout:
   the product page buy buttons, the cart drawer and the cart page.
   Added 29 Aug 2026, after American Express was switched off: iyzico
   accepts Amex for TRY only, so USD orders on an Amex card fail
   after 3-D Secure.
   9 Sep 2026: in the cart drawer and cart page a second line is added
   above the card note - free US/CA/UK shipping, no customs, made to order.
   Mobile checkout data (30 days): 7 of 7 mobile checkouts abandoned; the
   cart is the last on-site screen before the iyzico redirect.
   The Visa and Mastercard marks are cloned from the #slx-card-icons
   template in snippets/stylesheets.liquid, which renders Shopify's own
   payment icons. */
(function () {
  'use strict';

  var NOTE_CLASS = 'slx-pay-note';
  var TEXT = 'Secure checkout — we accept Visa & Mastercard';
  var CART_TEXT = 'Free shipping to the US, Canada & UK · No customs or duties · Made to order in 2–4 days';

  /* The mobile sticky bar has no room for the note. Match the bar itself,
     not any class containing "sticky" - the desktop product column carries
     sticky-content--desktop and would be skipped by mistake. */
  var STICKY = 'sticky-add-to-cart, .sticky-add-to-cart__bar';

  var STYLE =
    '.slx-pay-note{margin-top:.7rem;text-align:center;}' +
    '.slx-pay-note__text{display:flex;align-items:center;justify-content:center;' +
    'gap:.4em;margin:0;font-size:.78rem;line-height:1.35;' +
    'color:rgba(46,58,44,.62);}' +
    '.slx-pay-note__text svg{width:.95em;height:.95em;flex:0 0 auto;opacity:.75;}' +
    '.slx-pay-note__cards{display:flex;align-items:center;justify-content:center;' +
    'gap:.35rem;margin-top:.4rem;}' +
    '.slx-pay-note__cards svg{width:34px;height:22px;display:block;}' +
    '.slx-pay-note__ship{display:block;margin:0 0 .45rem;font-size:.78rem;line-height:1.4;' +
    'font-weight:600;color:rgba(46,58,44,.85);}';

  var LOCK =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<rect x="4" y="10" width="16" height="11" rx="2"></rect>' +
    '<path d="M8 10V7a4 4 0 0 1 8 0v3"></path></svg>';

  function injectStyle() {
    if (document.getElementById('slx-pay-note-style')) return;
    var style = document.createElement('style');
    style.id = 'slx-pay-note-style';
    style.textContent = STYLE;
    document.head.appendChild(style);
  }

  function buildNote(withShipping) {
    var note = document.createElement('div');
    note.className = NOTE_CLASS;

    if (withShipping) {
      var ship = document.createElement('p');
      ship.className = 'slx-pay-note__ship';
      ship.textContent = CART_TEXT;
      note.appendChild(ship);
    }

    var line = document.createElement('p');
    line.className = 'slx-pay-note__text';
    line.innerHTML = LOCK + '<span></span>';
    line.querySelector('span').textContent = TEXT;
    note.appendChild(line);

    var template = document.getElementById('slx-card-icons');
    if (template && template.content && template.content.childElementCount) {
      var cards = document.createElement('span');
      cards.className = 'slx-pay-note__cards';
      cards.setAttribute('aria-hidden', 'true');
      cards.appendChild(template.content.cloneNode(true));
      note.appendChild(cards);
    }

    return note;
  }

  function hasNote(container) {
    return !!container.querySelector('.' + NOTE_CLASS);
  }

  /* Product page: under the Add to cart / Buy it now buttons. */
  function addToProductForm() {
    var blocks = document.querySelectorAll('.buy-buttons-block');
    for (var i = 0; i < blocks.length; i++) {
      var block = blocks[i];
      if (block.closest(STICKY)) continue;
      if (hasNote(block)) continue;
      block.appendChild(buildNote(false));
    }
  }

  /* Cart drawer and cart page: under the Check out button. */
  function addToCart() {
    var buttons = document.querySelectorAll('button[name="checkout"]');
    for (var i = 0; i < buttons.length; i++) {
      var holder = buttons[i].parentElement;
      if (!holder || holder.closest(STICKY)) continue;
      if (hasNote(holder)) continue;
      holder.appendChild(buildNote(true));
    }
  }

  function run() {
    injectStyle();
    addToProductForm();
    addToCart();
  }

  var frame = null;
  function schedule() {
    if (frame) return;
    frame = window.requestAnimationFrame(function () {
      frame = null;
      run();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* The cart drawer rebuilds its contents on every cart update, and the
     buy buttons re-render when a variant changes. */
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
